import { CircularProgress } from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';
import { ReactElement } from 'react';
import { Button, ButtonProps, Identifier } from 'react-admin';
import { useRunScanMutation } from './utils';

interface ScanButtonProps extends ButtonProps {
  merchantId?: Identifier;
}

export default function ScanButton({
  merchantId,
  label = 'Run Scan',
  variant = 'contained',
  color = 'primary',
  ...props
}: ScanButtonProps): ReactElement {
  const { handleRunScan, isLoading } = useRunScanMutation(merchantId);
  return (
    <Button
      label={label}
      variant={variant}
      color={color}
      disabled={isLoading}
      startIcon={isLoading ? <CircularProgress size={16} /> : <WifiIcon fontSize="small" />}
      onClick={handleRunScan}
      {...props}
    />
  );
}
